import React from "react";
//#region types
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
//#endregion
//#region components
import { FileViewerContainer } from "components/common";
import useInvoiceCreateContext from "../../contexts/create/useInvoiceContext";
//#endregion

const InvoiceTemplate: React.FC = (props) => {
  const invoiceCreateContext = useInvoiceCreateContext();

  const [fileMeta, setFileMeta] = React.useState<ImageMeta[]>();

  React.useEffect(() => {
    setFileMeta(
      invoiceCreateContext.invoiceHtml
        ? [
            {
              id: 0,
              contentType: "html",
              numberOfPages: 1,
              data: invoiceCreateContext.invoiceHtml,
            },
          ]
        : undefined
    );
  }, [invoiceCreateContext.invoiceHtml]);

  return <FileViewerContainer meta={fileMeta} parentId={0} preventDownload />;
};

export default InvoiceTemplate;
